import dashboard from './view.dashboard';
import landing from './view.landing';
import notFound from './view.404';
import privacyPolicy from './view.privacyPolicy';
import removeAccount from './view.removeAccount';
import signIn from './view.signIn';
import signOut from './view.signOut';
import signUp from './view.signUp';

const view = {
  dashboard,
  landing,
  notFound,
  privacyPolicy,
  removeAccount,
  signIn,
  signOut,
  signUp,
};

export default view;
